function RMMDataViewerController(userViewService) {
  const ctrl = this;

  ctrl.$onInit = () => {
    userViewService.setView('configuration');
  };
}

angular
  .module('configuration-management.module')
  .controller('RMMDataViewerController', RMMDataViewerController);
